/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `MISSING_DETECTION` - Object not detected
* `INCORRECT_DETECTION` - Incorrect object detected
* `OTHER` - Other - please specify
 */
export type FeedbackTypeEnum = typeof FeedbackTypeEnum[keyof typeof FeedbackTypeEnum];


export const FeedbackTypeEnum = {
  MISSING_DETECTION: 'MISSING_DETECTION',
  INCORRECT_DETECTION: 'INCORRECT_DETECTION',
  OTHER: 'OTHER',
} as const;
